import { instance } from '@/api';

export const fetchRanks = (params: any) => {
  return instance.get(`/records/rank`, {
    params: {
      ...params,
    },
  });
};
